import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const AppFeedback = lazyRouteComponent(() => import('../../pages/profile/app-feedback'))

export const appFeedbackRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: '/feedback',
  component: AppFeedback,
})
